import { Box, Button, Checkbox, Stack, Text } from '@chakra-ui/react'
import 'mathquill/build/mathquill.css'
import dynamic from 'next/dynamic'
import { useSlate } from 'slate-react'

import ModalV3 from '../../Modal/ModalV3'
import { isMathActive, type MathElementDetails, removeMath, setMathElementDetails } from './math'

const EditableMathField = dynamic(async () => (await import('react-mathquill')).EditableMathField, {
  ssr: false,
})

export default function CreateOrUpdateMathModal({
  showModal,
  setShowModal,
  math,
  setMath,
}: {
  showModal: boolean
  setShowModal: (show: boolean) => void
  math: MathElementDetails
  setMath: React.Dispatch<React.SetStateAction<MathElementDetails>>
}): React.ReactElement {
  const editor = useSlate()
  return (
    <ModalV3
      size="lg"
      title="Equation"
      open={showModal}
      onClose={() => {
        setShowModal(false)
      }}
      rightFooterContent={() => (
        <Stack justify="flex-end" spacing={2} direction="row" mt={4}>
          {isMathActive(editor) ? (
            <Button
              variant="danger-outline"
              onClick={() => {
                removeMath(editor)
                setShowModal(false)
              }}
            >
              Remove
            </Button>
          ) : null}
          <Button
            type="submit"
            onClick={() => {
              setMathElementDetails(editor, math)
              setShowModal(false)
            }}
          >
            Save
          </Button>
        </Stack>
      )}
      body={() => (
        <Stack direction="column" spacing={3}>
          <Text fontWeight="bold">Please enter an equation:</Text>
          <EditableMathField
            latex={math?.latex ?? ''}
            onChange={equation => setMath(m => ({ ...m, latex: equation.latex() }))}
            style={{ padding: '8px', borderRadius: '4px', borderColor: 'border' }}
          />
          <Checkbox
            mt={6}
            isChecked={math.displayMode}
            onChange={e => setMath(m => ({ ...m, displayMode: e.target.checked }))}
          >
            <Box mt="-3px">Use display mode</Box>
          </Checkbox>
        </Stack>
      )}
    />
  )
}
